<div> <button mat-icon-button [mat-dialog-close]="{cancel: true}" class="close-dialog">
        <mat-icon>close</mat-icon>
    </button>
    <h2 mat-dialog-title> {{action}} Service </h2>
    <div class="mat-dialog-title-content">
        <div class="scroll-container">
            <eca-form-column>
                <form [formGroup]="form">
                    <mat-form-field>
                        <mat-label>Service Name</mat-label>
                        <input matInput formControlName="name" required>
                        <mat-error>Name is required</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Service Description</mat-label>
                        <textarea matInput formControlName="description" required></textarea>
                        <mat-error>Description is required</mat-error>
                    </mat-form-field>
                </form>
            </eca-form-column>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button [mat-dialog-close]="{cancel: true}"> Cancel </button>
        <button mat-button color="primary" [mat-dialog-close]="{cancel: false, form: form}" [disabled]="form.invalid"> {{action}} Service </button>
    </div>
</div>